import { render, staticRenderFns } from "./BannerAd.vue?vue&type=template&id=3a20837f"
import script from "./BannerAd.vue?vue&type=script&lang=js"
export * from "./BannerAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports